import { createActionCreator } from '@pressreader/appstore';
import { IUserCollection } from '@pressreader/social-types';

import { MODULE_NAME } from '../../constants';

const pre = MODULE_NAME + '/user_collections/';

interface ILoadUserCollectionsDonePayload {
    collections: IUserCollection[];
}

interface ILoadUserCollectionsFailedPayload {
    error: unknown;
}

const loadUserCollectionsAction = createActionCreator<{
    /**
     * @default false
     */
    isForce?: boolean;
}>(`${pre}load_user_collections_action`);
const loadUserCollectionsBegan = createActionCreator(`${pre}load_user_collections_began`);
const loadUserCollectionsDone = createActionCreator<ILoadUserCollectionsDonePayload>(`${pre}load_user_collections_done`);
const loadUserCollectionsFailed = createActionCreator<ILoadUserCollectionsFailedPayload>(`${pre}load_user_collections_failed`);
const loadUserCollectionsCancelled = createActionCreator(`${pre}load_user_collections_cancelled`);
const resetUserCollectionsAction = createActionCreator(`${pre}reset_user_collections_action`);

const loadUserCollectionsFinishedActionList = Object.freeze([loadUserCollectionsDone, loadUserCollectionsFailed, loadUserCollectionsCancelled]);

export {
    loadUserCollectionsBegan,
    loadUserCollectionsDone,
    loadUserCollectionsFailed,
    resetUserCollectionsAction,
    loadUserCollectionsAction,
    loadUserCollectionsCancelled,
    loadUserCollectionsFinishedActionList,
};
